var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 185,
    viewBox: "0 0 156 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.96167 184C136.13 151.233 161.27 94.7286 153.817 -47.2505",
    stroke: "#3971E7",
    strokeWidth: 0.990366
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4856 170.63C134.087 137.863 159.31 81.3587 151.832 -60.6204",
    stroke: "#3971E7",
    strokeWidth: 0.990366
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 158.25C132.169 125.483 157.308 68.9791 149.855 -73",
    stroke: "#3971E7",
    strokeWidth: 0.990366
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroline);
export default __webpack_public_path__ + "static/media/heroline.0c959c88bac0d75c4111e96ec79c07c4.svg";
export { ForwardRef as ReactComponent };